import { ReactNode } from 'react';
import { useSelector, useDispatch } from 'react-redux';

import automationRulesReducer from '@app/reducers/entities/automation-rules';

import { T } from '@app/components/translation';
import { RemoveConfirm } from '@app/components/modals/remove-confirm';
import { AutomationRuleName } from '@app/components/automation-rule-name';

import { BadgeName } from '@app/components/badges/badge-name';

type Props = {
  children: ReactNode | ((onClick: () => void) => JSX.Element);
  automationRule: Oneflow.AutomationRule;
};

const DeleteAutomationRule = ({ children, automationRule }: Props) => {
  const { id } = automationRule;
  const dispatch = useDispatch();

  const formState = useSelector((state) =>
    automationRulesReducer.getRemoveSelector(state, {
      id,
    }),
  );

  const resetRemoveState = () => {
    dispatch(
      automationRulesReducer.removeAutomationRuleReset({
        id,
      }),
    );
  };

  const removeAutomationRule = () => {
    dispatch(
      automationRulesReducer.removeAutomationRule({
        id,
      }),
    );
  };

  return (
    <RemoveConfirm
      onConfirm={removeAutomationRule}
      confirmState={formState}
      resetConfirmState={resetRemoveState}
      onClose={resetRemoveState}
      confirmMessage={
        <T
          _str="You are about to delete {name}. This action can't be undone."
          name={
            <BadgeName>
              <AutomationRuleName automationRule={automationRule} />
            </BadgeName>
          }
          _comment="Modal text when removing automation rule"
        />
      }
      modalKey="remove automation rule"
    >
      {children}
    </RemoveConfirm>
  );
};

export default DeleteAutomationRule;
